module.exports = __webpack_public_path__ + "img/standard-clean2.0a95e791.jpg";